<div class="composer">
  @if (attachments().length || (!audioRecorded() && audio()) || video()) {
    <app-ticket-selected-uploads
      [attachments]="attachments()"
      [audio]="audio()"
      [audioRecorded]="audioRecorded()"
      [video]="video()"
      [previewUrl]="previewImageUrl"
      [labels]="{
        previewAttachment: labels().previewAttachment,
        removeFile: labels().removeFile
      }"
      (attachmentRemoved)="removeAttachment($event)"
      (audioRemoved)="clearAudio()"
      (videoRemoved)="clearVideo()"
      (attachmentOpened)="openSelectedAttachment($event)"
      (imageFailed)="imageLoadFailed($event)"
    />
  }

  <div class="composer-box">
    <textarea
      #replyInput
      class="input input-md"
      [ngModel]="text()"
      (ngModelChange)="text.set($event)"
      rows="2"
      [placeholder]="labels().placeholder"
      [attr.maxlength]="maxMessageLength"
      (keydown)="onKeydown($event)"
      (paste)="onPaste($event)"
    ></textarea>
    <div class="composer-actions">
      <div class="composer-tools">
        <label class="ticket-tool" [title]="labels().attachmentLimits">
          <ng-icon name="attachment" size="19" />
          <span>{{ labels().attachFiles }}</span>
          <input
            type="file"
            multiple
            [accept]="messageFileAccept"
            (change)="selectFiles($event)"
          />
        </label>
        <app-ticket-audio-recorder
          [selectedFile]="audioRecorded() ? audio() : null"
          (fileChange)="setRecordedAudio($event)"
        />
      </div>
      <div class="composer-submit">
        <span
          class="message-counter"
          [class.near-limit]="text().length >= maxMessageLength * 0.8"
        >{{ text().length }}/{{ maxMessageLength }}</span>
        <button
          class="send-button"
          buttonTheme="primary"
          buttonType="regular"
          size="sm"
          type="button"
          [disabled]="!canSend()"
          (click)="submit()"
        >
          <ng-icon name="send" size="18" />
          <span>{{ sending() ? labels().sending : labels().send }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-ticket-attachment-preview
  [downloadLabel]="labels().download"
  [closeLabel]="labels().closePreview"
  [loadingLabel]="labels().loadingPreview"
  [sheetLabel]="labels().spreadsheetSheet"
  [emptySheetLabel]="labels().spreadsheetEmptySheet"
  [truncatedLabel]="labels().spreadsheetPreviewTruncated"
  (failed)="previewFailed.emit()"
/>
